var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('el-image',{staticClass:"img-demo",attrs:{"src":_vm.imgList[_vm.tmpType-1],"fit":"cover"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }